"use strict";
var ISurvey = require("../Api/ISurvey");
var ISurveyComponent = require("../Api/ISurveyComponent");
var CommentComponent = require("../SurveyComponents/CommentComponent");
var PromptComponent = require("../SurveyComponents/PromptComponent");
var RatingComponent = require("../SurveyComponents/RatingComponent");
var Utils = require("../Utils");
var SurveyDataSource = require("./SurveyDataSource");
var FpsSurvey = /** @class */ (function () {
    function FpsSurvey(data) {
        if (Utils.isNullOrUndefined(data)) {
            throw new Error("data must not be null");
        }
        this.surveyInfo = new SurveyDataSource(data.baseData);
        this.prompt = new PromptComponent(data.promptData);
        this.question = new CommentComponent(data.commentData);
        this.rating = new RatingComponent(data.ratingData);
    }
    FpsSurvey.make = function (data) {
        try {
            return new FpsSurvey(data);
        }
        catch (e) {
            return null;
        }
    };
    FpsSurvey.makeFps = function (baseData, sp, surveyModel) {
        if (Utils.isNullOrUndefined(baseData) || Utils.isNullOrUndefined(sp) || Utils.isNullOrUndefined(surveyModel)) {
            return null;
        }
        var ratingValuesAscending = [];
        var content = surveyModel.content;
        if (Utils.isNullOrUndefined(content) || Utils.isNullOrUndefined(content.comment)
            || Utils.isNullOrUndefined(content.prompt) || Utils.isNullOrUndefined(content.rating)) {
            return null;
        }
        var data = new FpsSurvey.FpsSurveyData();
        data.baseData = baseData;
        data.promptData = new PromptComponent.PromptComponentData();
        data.ratingData = new RatingComponent.RatingComponentData();
        data.commentData = new CommentComponent.CommentComponentData();
        data.promptData.title = sp.getCustomString(content.prompt.title);
        data.promptData.question = sp.getCustomString(content.prompt.question);
        data.promptData.yesButtonLabel = sp.getCustomString(content.prompt.yesLabel);
        data.promptData.noButtonLabel = sp.getCustomString(content.prompt.noLabel);
        data.ratingData.question = sp.getCustomString(content.rating.question);
        data.ratingData.isZeroBased = content.rating.isZeroBased;
        data.commentData.question = sp.getCustomString(content.comment.question);
        for (var _i = 0, _a = content.rating.ratingValuesAscending; _i < _a.length; _i++) {
            var value = _a[_i];
            var customString = sp.getCustomString(value);
            if (Utils.isNullOrUndefined(customString)) {
                return null;
            }
            ratingValuesAscending.push(customString);
        }
        data.ratingData.ratingValuesAscending = ratingValuesAscending;
        if (Utils.isNullOrUndefined(data.ratingData.question)
            || Utils.isNullOrUndefined(data.commentData.question)
            || Utils.isNullOrUndefined(data.promptData.title)
            || Utils.isNullOrUndefined(data.promptData.question)
            || Utils.isNullOrUndefined(data.promptData.yesButtonLabel)
            || Utils.isNullOrUndefined(data.promptData.noButtonLabel)
            || Utils.isNullOrUndefined(data.ratingData.ratingValuesAscending)) {
            return null;
        }
        return this.make(data);
    };
    // @Override
    FpsSurvey.prototype.getType = function () {
        return ISurvey.Type.Fps;
    };
    // @Override
    FpsSurvey.prototype.getSurveyInfo = function () {
        return this.surveyInfo;
    };
    // @Override
    FpsSurvey.prototype.getCommentComponent = function () {
        return this.question;
    };
    // @Override
    FpsSurvey.prototype.getPromptComponent = function () {
        return this.prompt;
    };
    // @Override
    FpsSurvey.prototype.getRatingComponent = function () {
        return this.rating;
    };
    // @Override
    FpsSurvey.prototype.getComponent = function (componentType) {
        switch (componentType) {
            case ISurveyComponent.Type.Comment:
                return this.getCommentComponent();
            case ISurveyComponent.Type.Prompt:
                return this.getPromptComponent();
            case ISurveyComponent.Type.Rating:
                return this.getRatingComponent();
            default:
                return null;
        }
    };
    // @Override
    FpsSurvey.prototype.getDomElements = function (doc) {
        if (Utils.isNullOrUndefined(doc)) {
            throw new Error("Document must not be null");
        }
        var element = doc.createElement(ISurvey.DOM_FPS_TAGNAME);
        this.getSurveyInfo().getDomElements(doc).forEach(function (child) {
            if (!Utils.isNullOrUndefined(child)) {
                element.appendChild(child);
            }
        });
        this.getCommentComponent().getDomElements(doc).forEach(function (child) {
            if (!Utils.isNullOrUndefined(child)) {
                element.appendChild(child);
            }
        });
        this.getRatingComponent().getDomElements(doc).forEach(function (child) {
            if (!Utils.isNullOrUndefined(child)) {
                element.appendChild(child);
            }
        });
        return [element];
    };
    // @Override
    FpsSurvey.prototype.getJsonElements = function () {
        var result = {};
        result = Utils.overrideValues(this.getSurveyInfo().getJsonElements(), result);
        result = Utils.overrideValues(this.getCommentComponent().getJsonElements(), result);
        result = Utils.overrideValues(this.getRatingComponent().getJsonElements(), result);
        return result;
    };
    return FpsSurvey;
}());
(function (FpsSurvey) {
    /**
     * Data required for a Fps Survey
     */
    var FpsSurveyData = /** @class */ (function () {
        function FpsSurveyData() {
        }
        return FpsSurveyData;
    }());
    FpsSurvey.FpsSurveyData = FpsSurveyData;
})(FpsSurvey || (FpsSurvey = {}));
module.exports = FpsSurvey;
